import panelControl from '@/utils/contral/panelControl';
import panelConfig from '@/utils/configs/panelConfig';
import store from '../../store';
// 弹窗
import eventLayerPanel from '@/components/UE4Panel/eventLayerPanel'
import PublicPanel from '@/components/UE4Panel/PublicPanel'
import VesselInformation from '@/components/UE4Panel/VesselInformation'
import InspectionPersonnel from '@/components/UE4Panel/InspectionPersonnel'
import ContainerTruck from '@/components/UE4Panel/ContainerTruck'
import Camera from '@/components/UE4Panel/Camera'

let {
	prevModelLayer
} = store.state
export default class overlayTip {
	static PanelSetting = {
		告警事件: {
			com: eventLayerPanel,
			size: [800, 425],
			offset: [50, 80],
		},
		BridgeCrane: {
			com: PublicPanel,
			size: [800, 425],
			offset: [0, 0],
		},
		Container: {
			com: PublicPanel,
			size: [800, 425],
			offset: [0, 0],
		},
		GantryCrane: {
			com: PublicPanel,
			size: [800, 425],
			offset: [0, 0],
		},
		car: {
			com: ContainerTruck,
			size: [800, 425],
			offset: [0, 0],
		},
		person: {
			com: InspectionPersonnel,
			size: [800, 425],
			offset: [0, 0],
		},
		ship: {
			com: VesselInformation,
			size: [800, 425],
			offset: [0, 0],
		},
		camera:{
			com: Camera,
			size: [800, 425],
			offset: [0, 0],
		}
	};
	static prevLayer = ''; // 上一次添加的tip
	static addOverLayTip (res) {
		// 标牌排他
		if (this.prevLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeOverlayTip', {
				...this.prevLayer
			});
		}
		let item = panelConfig.getPanelIfon(res);
		let ele = null;
		if (res.nameArea) {
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				item.rawData
			);
		} else {
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				item.rawData
			);
		}

		appInstance.uniCall(
			'addOverlayTip', {
			id: res.idObj || res.nameArea,
			url: '',
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting[item.scatterType].offset || [0, 0],
			overlayType: item.layerType,
			isShowClose: false,
			divId: ele.id
		},
			tip => {
				console.log(tip);
			}
		);
		this.prevLayer = {
			overlayType: item.layerType,
			id: res.idObj
		};
	}
	static addAreaOverLayTip (res) {
		let item = panelConfig.getPanelIfon(res);
		let info = JSON.parse(window.sessionStorage.getItem(res.idLayer));
		let ele = null;
		let changjing2 = 1;
		if (res.nameArea) {
			let areaInfo = info.data.filter(item => item.id === res.nameArea);
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				areaInfo[0],
				changjing2
			);
		} else {
			let rowData = info.data.filter(item => {
				if (item.id == res.idObj) return item;
			});
			ele = panelControl.create(
				res.idObj || res.nameArea,
				this.PanelSetting[item.scatterType].com,
				rowData
			);
		}

		appInstance.uniCall(
			'addOverlayTip', {
			id: res.idObj || res.nameArea,
			url: '',
			size: [ele.clientWidth, ele.clientHeight],
			offset: this.PanelSetting[item.scatterType].offset || [0, 0],
			overlayType: item.layerType,
			isShowClose: false,
			divId: ele.id
		},
			tip => {
				console.log(tip);
			}
		);
		this.prevLayer = {
			overlayType: item.layerType,
			id: res.nameArea
		};
	}
	static addModelTip (res) {
		//获取数据
		// let { id, selected, meta, idLayer } = res;
		if (this.prevModelLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeModelTip', {
				...this.prevModelLayer
			});
		}
		const ele = panelControl.create(
			res.modelId,
			this.PanelSetting[res.Key].com,
			res,
			'model'
		);

		window.appInstance.uniCall(
			'addModelTip', {
			id: res.modelId,
			url: '',
			divId: ele.id,
			isShowClose: true,
			// 分辨率原因 此处配置全部缩小2倍
			size: [ele.clientWidth, ele.clientHeight],
			offset: [0, 0]
		},
			res => {
				console.log(res);
			}
		);

		this.prevModelLayer = {
			id: res.modelId
		};
		store.commit('setModelTip', this.prevModelLayer);
	}

	static removeOverLayTip () {
		if (this.prevLayer) {
			panelControl.destroy();
			window.appInstance.uniCall('removeOverlayTip', {
				...this.prevLayer
			});
			this.prevLayer = '';
		}
	}
}